import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = () => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <SimplePageContentWrapper><RecordsTable/></SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
